import { ExclamationCircleOutlined } from '@ant-design/icons';
import confirm from 'antd/lib/modal/confirm';
import React from 'react'; 
import { EnvConstants } from '../../../../EnvConstants'; 

import BarButtonFw, { BUTTON_DEFAULT } from '../../../../framework/bar-button/BarButtonFw';
import FormFw from '../../../../framework/form/FormFw';
import { BasePage } from '../../../../framework/pages/BasePage';
import { LoadUtil } from '../../../../framework/util/LoadUtil';
import { MessageUtil } from '../../../../util/MessageUtil';
import { UserUtil } from '../../../../util/UserUtil'; 
import { getGridServerDefaultParams } from '../../../shared/util/getGridServerDefaultParams';
import GridFw from '../../../../framework/grid/GridFw';
import './Modal.css';

export class DuplicarCotizacionModal extends BasePage {
    createPageProperties = (pageApi) => {
        return {
            title: 'Ingrese Empresa para el Duplicado',
        };
    }
    
    renderPage(pageApi) {
        const getFormDuplicado = () => pageApi.getComponent('duplicadoForm');
        const getGrid = () => pageApi.name.grid;
        const getData = () => pageApi.name.data;
 
        const formGridConfig = {
            layout: 'vertical',
            fields:[
                {type: 'select', name:'id_empresa', label:'Empresa', column: 6,
                     load: {queryId: 861, 
                         params: { id_user: UserUtil.getUserId() }}, 
                 search: true,
                 value:pageApi?.name?.data?.id_empresa
                },
                {type: 'select', name:'id_servicio', label:'Tipo Servicio', column: 6, load: {queryId: 128}, search: true, value: getData()?.id_servicio },
            ],
        };
        
        const barHeaderConfig = {
            fields:[
                {...BUTTON_DEFAULT.SAVE, label:'Guardar', onClick: ()=>{
                    let id_empresa = getFormDuplicado()?.getData().id_empresa;
                    let id_servicio = getFormDuplicado()?.getData().id_servicio;

                    if(id_empresa){
                        LoadUtil.loadByQueryId({
                            url: EnvConstants.GET_FW_FORM_URL_LOAD_BASE(),
                            queryId: 766,
                            reqParams: {
                                params: {
                                    id_user: UserUtil.getUserId(), 
                                    id_empresa, id_doc: pageApi?.name?.data?.id_doc
                                }
                            },
                            fnOk: (resp) => {
                                const listaResp = resp.dataList ?? []; 
                                const esVacioResp = (listaResp.length === 0);
                                const anchoModal = esVacioResp ? "40%" : "60%";
                                const ContenidoModal = () => {
                                    if (esVacioResp) return <></>;

                                    const grid = {
                                        ...getGridServerDefaultParams({
                                            queryLoad: 766,
                                            params: { id_user: UserUtil.getUserId(), id_empresa, id_doc: pageApi?.name?.data?.id_doc }
                                        }),
                                        pagination: {
                                            server: true,
                                            showSizeChanger: true
                                        },
                                        fields: [
                                            {name: 'Item', label: 'Item'},
                                            {name: 'Matriz', label: 'Matriz'},
                                            {name: 'IDMetodo', label: 'ID Método'},
                                            {name: 'NombreMetodo', label: 'Método'},
                                            {name: 'Lab', label: 'Lab'},
                                        ]
                                    }

                                    return (
                                        <>
                                            <br />
                                            <p>Estos parametros no se encuentran en su tarifario: </p>
                                            <GridFw
                                                name="grid"
                                                getParentApi={pageApi.getApi}
                                                config={grid}
                                            />
                                        </>
                                    )
                                };

                                confirm({
                                    title: `Desea Clonar esta Cotización? Cotización ${pageApi?.name?.data?.doc_nro}`,
                                    icon: <ExclamationCircleOutlined />,
                                    width: anchoModal,
                                    className: "modalClonarCotizacion",
                                    content: <ContenidoModal />,
                                    onOk() {
                                        LoadUtil.loadByQueryId({
                                            url: EnvConstants.GET_FW_FORM_URL_UPDATE_BASE(),
                                            queryId: 308,
                                            params: {id_doc: pageApi?.name?.data?.id_doc, id_user: UserUtil.getUserId(), id_empresa, id_servicio },
                                            fnOk: (resp) => {
                                                const { doc_nro } = resp.dataObject;
                                                pageApi.hideThisModal();
                                                MessageUtil('success','La Clonación se realizó con éxito. Cotizacion ' + doc_nro,'');
                                                getGrid().load();
                                            }
                                        });
                                    },
                                    onCancel() { },
                                });
                            }
                        })
                    }
                    else{
                        return MessageUtil('warning','Alerta!','Debe Seleccionar Empresa');
                    }
                   }
                },
                {...BUTTON_DEFAULT.RETURN, onClick: () => pageApi.hideThisModal()}
            ]
        };
    
        return (
            <>
                <FormFw 
                    name="duplicadoForm" 
                    getParentApi={pageApi.getApi}
                    config={formGridConfig}
                />

                <BarButtonFw 
                    name="buttonGastos" 
                    getParentApi={pageApi.getApi}
                    config={barHeaderConfig}
                />
            </>
        )
    }
}